import { useSelector } from 'react-redux';

import {
  putBehavioralAboutDrawerCTAClicked,
  putBehavioralAcitivityFeedMapGalleryClicked,
  putBehavioralActivityFeedMeetSomeoneNewClcked,
  putBehavioralActivityFeedRadarActiveWorkClicked,
  putBehavioralActivityFeedRadarEventsClicked,
  putBehavioralActivityFeedRadarPressClicked,
  putBehavioralActivityFeedRadarTrendingClicked,
  putBehavioralActivityFeedRadarTrendingPillClicked,
  putBehavioralActivityFeedSpotlightClicked,
  putBehavioralAnchorTagClicked,
  putBehavioralArticleContributorClicked,
  putBehavioralArticleProfileLinkOutClicked,
  putBehavioralBuildProfileClicked,
  putBehavioralCommonGroundCarouselClicked,
  putBehavioralContinueExploringClicked,
  putBehavioralConveningAttendeeClicked,
  putBehavioralConveningClicked,
  putBehavioralConveningHostClicked,
  putBehavioralDetailsAnnouncementClicked,
  putBehavioralEditProfileClicked,
  putBehavioralEmailCopied,
  putBehavioralFullProfileOpened,
  putBehavioralGlobalDrawerCTAClicked,
  putBehavioralGlobalMapOpen,
  putBehavioralItemClicked,
  putBehavioralLinkedinOpened,
  putBehavioralMapDetailsPageCTAClicked,
  putBehavioralMapLensClicked,
  putBehavioralMapNodeClicked,
  putBehavioralMapOpen,
  putBehavioralMeetSomeoneNewCarouselClicked,
  putBehavioralMeetSomeoneNewViewProfileClicked,
  putBehavioralNavAboutKyuOsClicked,
  putBehavioralNavCommunitiesClicked,
  putBehavioralNavDiscoverClicked,
  putBehavioralNavEventsClicked,
  putBehavioralNavHostAnEventClicked,
  putBehavioralNavNetworkMapsClicked,
  putBehavioralNavPeopleClicked,
  putBehavioralNavPitchAStoryClicked,
  putBehavioralNavProfileProgressBarClicked,
  putBehavioralNavResourcesClicked,
  putBehavioralNavSubmitAResourceClicked,
  putBehavioralNavTheWellClicked,
  putBehavioralNoProjectsClicked,
  putBehavioralPeopleDrawerFilterClicked,
  putBehavioralPeopleDrawerItemClicked,
  putBehavioralPeopleListCompanyDropdownClicked,
  putBehavioralPeopleListDrawerCTAClicked,
  putBehavioralPeopleListFiltersCTAClicked,
  putBehavioralPersonCardClicked,
  putBehavioralPlatformLinkCopied,
  putBehavioralReachCardClicked,
  putBehavioralReactionsListOpened,
  putBehavioralReactionsPersonDrawerCardClicked,
  putBehavioralReactionsProfileSeeAllClicked,
  putBehavioralReactionsViewProfileClicked,
  putBehavioralRegistrationLinkClicked,
  putBehavioralRequestChangeClicked,
  putBehavioralResourceCardCreatorClicked,
  putBehavioralResourceCardSubmitterClicked,
  putBehavioralResourceDetailCreatorClicked,
  putBehavioralResourceDetailsClicked,
  putBehavioralResourceLoadMoreClicked,
  putBehavioralResourceOpen,
  putBehavioralResourceRelatedPageClicked,
  putBehavioralResourceRelatedResourceClicked,
  putBehavioralResourceCreateCtaClicked,
  putBehavioralSearchLensClicked,
  putBehavioralSearchOptionsListItemClicked,
  putBehavioralShareBannerClicked,
  putBehavioralShareButtonClicked,
  putBehavioralSlackOpened,
  putBehavioralTOCClicked,
  putBehavioralTagCategoryClicked,
  putBehavioralTagSearchClicked,
  putBehavioralViewPublicProfileClicked,
  putBehavioralWatchRecapClicked,
  putCollectiveDirectoryOnboardingPromptClicked,
  putCollectiveDirectoryPersonCardClicked,
  putCollectiveDirectorySelectRecipientsClicked,
  putCollectiveDirectoryRefineResultsClicked,
  putCollectiveDirectoryQuickFilterClicked,
  putCollectiveDirectoryProfileCtaClicked,
  putCollectiveDirectorySearchClicked,
  putCollectiveDirectoryFilterMenuClicked,
  putCollectiveDirectoryFilterSectionClicked,
  putCollectiveDirectoryToggleClicked,
  putCollectiveDirectoryLoadMoreClicked,
  putContactFlowSelectAllClicked,
  putContactFlowCopyProfileClicked,
  putContactFlowDeselectProfileClicked,
  putContactFlowPartialMatchSelectionClicked,
  putContactFlowSendClicked,
  putContactFlowBackClicked,
  putContactFlowDismissed,
  putContactFlowEditProfileClicked,
  putBehavioralFeatureBannerDismissed,
  putBehavioralFeatureBannerCTAClicked,
  putBehavioralNavOpened,
  putBehavioralNavHomepageOpened,
  putBehavioralNavSpotlightOpened,
  putBehavioralNavSearchOpened,
  putBehavioralNavProfileMenuOpened,
  putCollectiveDirectoryPersonDrawerFilterClicked,
  putBehavioralSearchLensCollectiveDirectoryCTAClicked,
  putBehavioralPeopleListCollectiveDirectoryCTAClicked,
  putKyu101ProfileEditDrawerOpened,
  putKyu101PublicProfileCtaClicked,
  putKyu101ReachCtaClicked,
  putKyu101PeopleSectionCtaClicked,
  putKyu101CompanyPageCtaClicked,
  putKyu101CompanyClientsClicked,
  putKyu101CompaniesDrawerOpened,
  putKyu101ResourcesOpened,
  putKyu101TheWellOpened,
  putKyu101ConveningsOpened,
  putKyu101UsecasesOpened,
  putKyu101ContactFormOpened,
  putKyu101CasualIntentionCollectiveDirectoryOpened,
  putKyu101ExpertiseIntentionCollectiveDirectoryOpened,
  putKyu101ConveneIntentionCollectiveDirectoryOpened,
  putKyu101ClientsDrawerOpened,
  putKyu101GlobalIndustriesDrawerOpened,
  putKyu101CollectiveDirectoryOpened,
  putKyu101GlobalDisciplineDrawerOpened,
  putKyu101GlobalIndustryDrawerOpened,
  putKyu101GlobalClientDrawerOpened,
  putKyu101GlobalSkillDrawerOpened,
  putKyu101GlobalPassionDrawerOpened,
  putKyu101ResourceLibraryOpened,
  putKyu101FaqClicked,
  putKyu101ModalMinimized,
  putKyu101ModalExpanded,
  putKyu101ModalDismissed,
  putKyu101TocClicked,
  putTeamingPersonCardClicked,
  putTeamingRefineResultsClicked,
  putTeamingSearchClicked,
  putTeamingFilterMenuClicked,
  putTeamingFilterSectionClicked,
  putTeamingToggleClicked,
  putTeamingLoadMoreClicked,
  putTeamingContactBannerCtaClicked,
  putTeamingDrawerSelectCtaClicked,
  putTeamingDrawerViewProfileClicked,
  putTeamingDrawerWorkExperienceToggled,
  putTeamingContactFlowMessageCtaClicked,
  putTeamingContactFlowShareCtaClicked,
  putTeamingContactFlowRecipientTabClicked,
  putTeamingContactFlowEditMessageClicked,
  putTeamingContactFlowRemoveRecipientClicked,
  putTeamingContactFlowCcAdded,
  putTeamingContactFlowProfileDeselected,
  putTeamingContactFlowSendClicked,
  putTeamingContactFlowDismissed,
  putTeamingContactFlowBroadcastCtaClicked,
  putTeamingContactFlowEditProfileClicked,
  putPulseTabClicked,
  putPulseCompanySwitcherClicked,
  putPulseDomainLeadClicked,
  putPulseContactCtaClicked,
  putPulseWikiSearchClicked,
  putPulseWikiCardClicked,
  putPulseSpotlightLinkClicked,
  putPulseResourceClicked,
  putPulseFaqSectionTabClicked,
  putResourceVoteShareClicked,
  putBO24MostVotedClicked,
  putBO24TopContributorClicked,
  putBO24CategoryClicked,
  putBO24TopEntryClicked,
  putResourceBo24Filter,
  putPersonDrawerBo24Clicked,
  putProfileResourceClicked,
  putCollectiveIndexNlpSearchClicked,
  putCollectiveIndexNlpSearchEdit,
  putCollectiveIndexFilterIconClicked,
  putCollectiveIndexFiltersApplied,
  putTeamingNlpSearchClicked,
  putTeamingNlpSearchEdit,
  putTeamingFilterIconClicked,
  putTeamingFiltersApplied,
  putCollectiveDirectoryPrioritizeCriteriaClicked,
  putCollectiveDirectoryKeywordClicked,
  putCollectiveDirectoryFilterClicked,
  putCollectiveDirectoryAlternativeClicked,
  putTeamingAlternativeClicked,
  putTeamingFilterClicked,
  putTeamingKeywordClicked,
  putTeamingPrioritizeCriteriaClicked,
  putTeamingQuickFilterClicked,
  putCollectiveIndexDrawerSelectCTAClicked,
  putCollectiveIndexContactBannerCtaClicked,
  putAccountHolderClicked,
  putMessagePosted,
  putMessageEdited,
  putMessageDeleted,
  putMessageMentionSelected,
  putResourceFilterClicked,
  putResourceSearchShareCtaClicked,
  putResourceGetAssistanceClicked,
  putTeamingDrawerSendMessageClicked,
  putTeamingDrawerAddClicked,
  putTeamingShareListClicked,
  putTeamingBroadcastClicked,
  putBehavioralNavTeamingClicked,
  putBestOf2025SubmissionPhaseKyu101Clicked,
  putBestOf2025SubmissionPhaseLastYearResourcesClicked,
  putBestOf2025SubmissionPhaseResourceCreated,
  putBestOf2025SubmissionPhaseResourceEdited,
  putBestOf2025SubmissionPhaseResourceWithdrawn,
  putBestOfSubmissionPhaseKyu101Clicked,
  putBestOfSubmissionPhaseLastYearResourcesClicked,
  putBestOfSubmissionPhaseResourceCreated,
  putBestOfSubmissionPhaseResourceEdited,
  putBestOfSubmissionPhaseResourceWithdrawn,
  putBd100TabClicked,
  putBd100ProspectDetailsOpen,
  putBd100ProspectDetailsEdited,
  putBd100ProspectListFiltered,
  putBd100ProspectCollaborationFlag,
  putBd100ClientDrawerOpened,
  putBd100PersonDrawerOpened,
  putBehavioral,
} from 'services/behaviourals';
import { behavioralIdSelector } from 'store/reducers/user-reducer';

export const BEHAVIORALS = {
  LINKEDIN_OPENED: 'LINKEDIN_OPENED',
  SLACK_OPENED: 'SLACK_OPENED',
  EMAIL_COPIED: 'EMAIL_COPIED',
  FULL_PROFILE_OPENED: 'FULL_PROFILE_OPENED',
  MAP_OPENED: 'MAP_OPENED',
  PLATFORM_LINK_COPIED: 'PLATFORM_LINK_COPIED',
  SHARE_BANNER_CLICKED: 'SHARE_BANNER_CLICKED',
  GLOBAL_MAP_OPENED: 'GLOBAL_MAP_OPENED',
  CONVENING_CLICKED: 'CONVENING_CLICKED',
  CONVENING_ATTENDEE_CLICKED: 'CONVENING_ATTENDEE_CLICKED',
  CONVENING_HOST_CLICKED: 'CONVENING_HOST_CLICKED',
  REGISTRATION_LINK_CLICKED: 'REGISTRATION_LINK_CLICKED',
  WATCH_RECAP_CLICKED: 'WATCH_RECAP_CLICKED',
  CONTINUE_EXPLORING_CLICKED: 'CONTINUE_EXPLORING_CLICKED',
  ANCHOR_TAG_CLICKED: 'ANCHOR_TAG_CLICKED',
  ITEM_CLICKED: 'ITEM_CLICKED',
  ACTIVITY_FEED_SPOTLIGHT_CLICKED: 'ACTIVITY_FEED_SPOTLIGHT_CLICKED',
  ACTIVITY_FEED_RADAR_TRENDING_CLICKED: 'ACTIVITY_FEED_RADAR_TRENDING_CLICKED',
  ACTIVITY_FEED_RADAR_ACTIVE_WORK_CLICKED: 'ACTIVITY_FEED_RADAR_ACTIVE_WORK_CLICKED',
  ACTIVITY_FEED_RADAR_PRESS_CLICKED: 'ACTIVITY_FEED_RADAR_PRESS_CLICKED',
  ACTIVITY_FEED_RADAR_EVENTS_CLICKED: 'ACTIVITY_FEED_RADAR_EVENTS_CLICKED',
  ACTIVITY_FEED_MEET_SOMEONE_NEW_CLICKED: 'ACTIVITY_FEED_MEET_SOMEONE_NEW_CLICKED',
  ACTIVITY_FEED_MAP_GALLERY_CLICKED: 'ACTIVITY_FEED_MAP_GALLERY_CLICKED',
  ACTIVITY_FEED_RADAR_TRENDING_PILL_CLICKED: 'ACTIVITY_FEED_RADAR_TRENDING_PILL_CLICKED',
  DETAILS_ANNOUNCEMENT_CLICKED: 'DETAILS_ANNOUNCEMENT_CLICKED',
  PERSON_CARD_CLICKED: 'PERSON_CARD_CLICKED',
  ABOUT_DRAWER_CTA_CLICKED: 'ABOUT_DRAWER_CTA_CLICKED',
  TOC_CLICKED: 'TOC_CLICKED',
  PEOPLE_DRAWER_FILTER_CLICKED: 'PEOPLE_DRAWER_FILTER_CLICKED',
  PEOPLE_DRAWER_ITEM_CLICKED: 'PEOPLE_DRAWER_ITEM_CLICKED',
  COMMON_GROUND_CAROUSEL_CLICKED: 'COMMON_GROUND_CAROUSEL_CLICKED',
  ACCOUNT_HOLDER_CLICKED: 'ACCOUNT_HOLDER_CLICKED',

  //PEOPLE LIST
  PEOPLE_LIST_DRAWER_CTA_CLICKED: 'PEOPLE_LIST_DRAWER_CTA_CLICKED',
  PEOPLE_LIST_FILTERS_CTA_CLICKED: 'PEOPLE_LIST_FILTERS_CTA_CLICKED',
  PEOPLE_LIST_COMPANY_DROPDOWN_CLICKED: 'PEOPLE_LIST_COMPANY_DROPDOWN_CLICKED',
  PEOPLE_LIST_COLLECTIVE_DIRECTORY_CTA_CLICKED: 'PEOPLE_LIST_COLLECTIVE_DIRECTORY_CTA_CLICKED',

  //SEARCH LENSES
  SEARCH_LENS_CLICKED: 'SEARCH_LENS_CLICKED',
  SEARCH_LENS_COLLECTIVE_DIRECTORY_CTA_CLICKED: 'SEARCH_LENS_COLLECTIVE_DIRECTORY_CTA_CLICKED',

  //NAV
  NAV_ABOUT_KYU_OS: 'NAV_ABOUT_KYU_OS',
  NAV_NETWORK_MAPS: 'NAV_NETWORK_MAPS',
  NAV_THE_WELL: 'NAV_THE_WELL',
  NAV_COMMUNITIES: 'NAV_COMMUNITIES',
  NAV_EVENTS: 'NAV_EVENTS',
  NAV_DISCOVER: 'NAV_DISCOVER',
  NAV_HOST_AN_EVENT: 'NAV_HOST_AN_EVENT',
  NAV_PITCH_A_STORY: 'NAV_PITCH_A_STORY',
  NAV_SUBMIT_A_RESOURCE: 'NAV_SUBMIT_A_RESOURCE',
  NAV_RESOURCES: 'NAV_RESOURCES',
  NAV_PEOPLE: 'NAV_PEOPLE',
  NAV_TEAMING: 'NAV_TEAMING',
  NAV_OPENED: 'NAV_OPENED',
  NAV_HOMEPAGE_OPENED: 'NAV_HOMEPAGE_OPENED',
  NAV_SPOTLIGHT_OPENED: 'NAV_SPOTLIGHT_OPENED',
  NAV_SEARCH_OPENED: 'NAV_SEARCH_OPENED',
  NAV_PROFILE_MENU_OPENED: 'NAV_PROFILE_MENU_OPENED',

  // RESOURCES
  RESOURCE_DETAIL_CLICKED: 'RESOURCE_DETAIL_CLICKED',
  RESOURCE_TAG_CATEGORY_CLICKED: 'RESOURCE_TAG_CATEGORY_CLICKED',
  RESOURCE_TAG_SEARCH_CLICKED: 'RESOURCE_TAG_SEARCH_CLICKED',
  RESOURCE_RELATED_RESOURCE_CLICKED: 'RESOURCE_RELATED_RESOURCE_CLICKED',
  RESOURCE_RELATED_PAGE_CLICKED: 'RESOURCE_RELATED_PAGE_CLICKED',
  RESOURCE_LOAD_MORE_CLICKED: 'RESOURCE_LOAD_MORE_CLICKED',
  RESOURCE_OPENED: 'RESOURCE_OPENED',
  RESOURCE_CARD_SUBMITTER_CLICKED: 'RESOURCE_CARD_SUBMITTER_CLICKED',
  RESOURCE_CARD_CREATOR_CLICKED: 'RESOURCE_CARD_CREATOR_CLICKED',
  RESOURCE_DETAIL_CREATOR_CLICKED: 'RESOURCE_DETAIL_CREATOR_CLICKED',
  RESOURCE_CREATE_CTA_CLICKED: 'RESOURCE_CREATE_CTA_CLICKED',

  // DRAWER
  SEARCH_OPTIONS_LIST_ITEM_CLICKED: 'SEARCH_OPTIONS_LIST_ITEM_CLICKED',
  GLOBAL_DRAWER_CTA_CLICKED: 'GLOBAL_DRAWER_CTA_CLICKED',

  // MEET SOMEONE NEW
  MEET_SOMEONE_NEW_CAROUSEL_CLICKED: 'MEET_SOMEONE_NEW_CAROUSEL_CLICKED',
  MEET_SOMEONE_NEW_CAROUSEL_VIEW_PROFILE_CLICKED: 'MEET_SOMEONE_NEW_CAROUSEL_VIEW_PROFILE_CLICKED',

  // MAPS
  MAP_LENS_CLICKED: 'MAP_LENS_CLICKED',
  MAP_NODE_CLICKED: 'MAP_NODE_CLICKED',
  MAP_DETAILS_PAGE_CTA_CLICKED: 'MAP_DETAILS_PAGE_CTA_CLICKED',

  //PROFILE
  NAV_PROFILE_PROGRESS_BAR_CLICKED: 'NAV_PROFILE_PROGRESS_BAR_CLICKED',
  VIEW_PUBLIC_PROFILE_CLICKED: 'VIEW_PUBLIC_PROFILE_CLICKED',
  EDIT_PROFILE_CLICKED: 'EDIT_PROFILE_CLICKED',
  REACH_CARD_CLICKED: 'REACH_CARD_CLICKED',
  BUILD_PROFILE_CLICKED: 'BUILD_PROFILE_CLICKED',
  NO_PROJECTS_CLICKED: 'NO_PROJECTS_CLICKED',
  REQUEST_CHANGE_CLICKED: 'REQUEST_CHANGE_CLICKED',

  //ARTICLE
  ARTICLE_CONTRIBUTOR_CLICKED: 'ARTICLE_CONTRIBUTOR_CLICKED',
  ARTICLE_PROFILE_LINK_OUT_CLICKED: 'ARTICLE_PROFILE_LINK_OUT_CLICKED',

  //REACTIONS
  SHARE_BUTTON_CLICKED: 'SHARE_BUTTON_CLICKED',
  REACTIONS_LIST_OPENED: 'REACTIONS_LIST_OPENED',
  REACTIONS_VIEW_PROFILE_CLICKED: 'REACTIONS_VIEW_PROFILE_CLICKED',
  REACTIONS_PROFILE_SEE_ALL_CLICKED: 'REACTIONS_PROFILE_SEE_ALL_CLICKED',
  REACTIONS_PERSON_DRAWER_CARD_CLICKED: 'REACTIONS_PERSON_DRAWER_CARD_CLICKED',

  //BANNER
  FEATURE_BANNER_DISMISSED: 'FEATURE_BANNER_DISMISSED',
  FEATURE_BANNER_CTA_CLICKED: 'FEATURE_BANNER_CTA_CLICKED',

  //COLLECTIVE DIRECTORY ONBOARDING
  COLLECTIVE_DIRECTORY_ONBOARDING_PROMPT_CLICKED: 'COLLECTIVE_DIRECTORY_ONBOARDING_PROMPT_CLICKED',

  //COLLECTIVE DIRECTORY
  COLLECTIVE_DIRECTORY_PERSON_CARD_CLICKED: 'COLLECTIVE_DIRECTORY_PERSON_CARD_CLICKED',
  COLLECTIVE_DIRECTORY_SELECT_RECIPIENTS_CLICKED: 'COLLECTIVE_DIRECTORY_SELECT_RECIPIENTS_CLICKED',
  COLLECTIVE_DIRECTORY_REFINE_RESULTS_CLICKED: 'COLLECTIVE_DIRECTORY_REFINE_RESULTS_CLICKED',
  COLLECTIVE_DIRECTORY_QUICK_FILTER_CLICKED: 'COLLECTIVE_DIRECTORY_QUICK_FILTER_CLICKED',
  COLLECTIVE_DIRECTORY_PROFILE_CTA_CLICKED: 'COLLECTIVE_DIRECTORY_PROFILE_CTA_CLICKED',
  COLLECTIVE_DIRECTORY_SEARCH_RESULT_CLICKED: 'COLLECTIVE_DIRECTORY_SEARCH_RESULT_CLICKED',
  COLLECTIVE_DIRECTORY_FILTER_MENU_CLICKED: 'COLLECTIVE_DIRECTORY_FILTER_MENU_CLICKED',
  COLLECTIVE_DIRECTORY_FILTER_SECTION_CLICKED: 'COLLECTIVE_DIRECTORY_FILTER_SECTION_CLICKED',
  COLLECTIVE_DIRECTORY_TOGGLE_CLICKED: 'COLLECTIVE_DIRECTORY_TOGGLE_CLICKED',
  COLLECTIVE_DIRECTORY_LOAD_MORE_CLICKED: 'COLLECTIVE_DIRECTORY_LOAD_MORE_CLICKED',
  COLLECTIVE_DIRECTORY_PERSON_DRAWER_FILTER_CLICKED:
    'COLLECTIVE_DIRECTORY_PERSON_DRAWER_FILTER_CLICKED',
  COLLECTIVE_INDEX_NLP_SEARCH_CLICKED: 'COLLECTIVE_INDEX_NLP_SEARCH_CLICKED',
  COLLECTIVE_INDEX_NLP_SEARCH_EDIT: 'COLLECTIVE_INDEX_NLP_SEARCH_EDIT',
  COLLECTIVE_INDEX_FILTER_ICON_CLICKED: 'COLLECTIVE_INDEX_FILTER_ICON_CLICKED',
  COLLECTIVE_INDEX_FILTERS_APPLIED: 'COLLECTIVE_INDEX_FILTERS_APPLIED',
  COLLECTIVE_DIRECTORY_PRIORITIZE_CRITERIA_CLICKED: 'COLLECTIVE_INDEX_PRIORITIZE_CRITERIA_CLICKED',
  COLLECTIVE_DIRECTORY_KEYWORD_CLICKED: 'COLLECTIVE_INDEX_KEYWORD_CLICKED',
  COLLECTIVE_DIRECTORY_FILTER_CLICKED: 'COLLECTIVE_INDEX_FILTER_CLICKED',
  COLLECTIVE_DIRECTORY_ALTERNATIVE_CLICKED: 'COLLECTIVE_INDEX_ALTERNATIVE_CLICKED',
  COLLECTIVE_INDEX_DRAWER_SELECT_CTA_CLICKED: 'COLLECTIVE_INDEX_DRAWER_SELECT_CTA_CLICKED',
  COLLECTIVE_INDEX_CONTACT_BANNER_CTA_CLICKED: 'COLLECTIVE_INDEX_CONTACT_BANNER_CTA_CLICKED',

  //CONTACT FLOW
  CONTACT_FLOW_SELECT_ALL_CLICKED: 'CONTACT_FLOW_SELECT_ALL_CLICKED',
  CONTACT_FLOW_COPY_PROFILE_CLICKED: 'CONTACT_FLOW_COPY_PROFILE_CLICKED',
  CONTACT_FLOW_DESELECT_PROFILE_CLICKED: 'CONTACT_FLOW_DESELECT_PROFILE_CLICKED',
  CONTACT_FLOW_PARTIAL_MATCH_SELECTION_CLICKED: 'CONTACT_FLOW_PARTIAL_MATCH_SELECTION_CLICKED',
  CONTACT_FLOW_SEND_CLICKED: 'CONTACT_FLOW_SEND_CLICKED',
  CONTACT_FLOW_BACK_CLICKED: 'CONTACT_FLOW_BACK_CLICKED',
  CONTACT_FLOW_DISMISSED: 'CONTACT_FLOW_DISMISSED',
  CONTACT_FLOW_EDIT_PROFILE_CLICKED: 'CONTACT_FLOW_EDIT_PROFILE_CLICKED',

  //ABOUT KYU OS
  KYU101_PROFILE_EDIT_DRAWER_OPENED: 'KYU101_PROFILE_EDIT_DRAWER_OPENED',
  KYU101_PUBLIC_PROFILE_CTA_CLICKED: 'KYU101_PUBLIC_PROFILE_CTA_CLICKED',
  KYU101_REACH_CTA_CLICKED: 'KYU101_REACH_CTA_CLICKED',
  KYU101_PEOPLE_SECTION_CTA_CLICKED: 'KYU101_PEOPLE_SECTION_CTA_CLICKED',
  KYU101_COMPANY_PAGE_CTA_CLICKED: 'KYU101_COMPANY_PAGE_CTA_CLICKED',
  KYU101_COMPANY_CLIENTS_CLICKED: 'KYU101_COMPANY_CLIENTS_CLICKED',
  KYU101_COMPANIES_DRAWER_OPENED: 'KYU101_COMPANIES_DRAWER_OPENED',
  KYU101_RESOURCES_OPENED: 'KYU101_RESOURCES_OPENED',
  KYU101_THE_WELL_OPENED: 'KYU101_THE_WELL_OPENED',
  KYU101_CONVENINGS_OPENED: 'KYU101_CONVENINGS_OPENED',
  KYU101_USECASES_OPENED: 'KYU101_USECASES_OPENED',
  KYU101_CONTACT_FORM_OPENED: 'KYU101_CONTACT_FORM_OPENED',
  KYU101_CASUAL_INTENTION_COLLECTIVE_DIRECTORY_OPENED:
    'KYU101_CASUAL_INTENTION_COLLECTIVE_DIRECTORY_OPENED',
  KYU101_EXPERTISE_INTENTION_COLLECTIVE_DIRECTORY_OPENED:
    'KYU101_EXPERTISE_INTENTION_COLLECTIVE_DIRECTORY_OPENED',
  KYU101_CONVENE_INTENTION_COLLECTIVE_DIRECTORY_OPENED:
    'KYU101_CONVENE_INTENTION_COLLECTIVE_DIRECTORY_OPENED',
  KYU101_CLIENTS_DRAWER_OPENED: 'KYU101_CLIENTS_DRAWER_OPENED',
  KYU101_GLOBAL_INDUSTRIES_DRAWER_OPENED: 'KYU101_GLOBAL_INDUSTRIES_DRAWER_OPENED',
  KYU101_COLLECTIVE_DIRECTORY_OPENED: 'KYU101_COLLECTIVE_DIRECTORY_OPENED',
  KYU101_GLOBAL_DISCIPLINE_DRAWER_OPENED: 'KYU101_GLOBAL_DISCIPLINE_DRAWER_OPENED',
  KYU101_GLOBAL_INDUSTRY_DRAWER_OPENED: 'KYU101_GLOBAL_INDUSTRY_DRAWER_OPENED',
  KYU101_GLOBAL_CLIENT_DRAWER_OPENED: 'KYU101_GLOBAL_CLIENT_DRAWER_OPENED',
  KYU101_GLOBAL_SKILL_DRAWER_OPENED: 'KYU101_GLOBAL_SKILL_DRAWER_OPENED',
  KYU101_GLOBAL_PASSION_DRAWER_OPENED: 'KYU101_GLOBAL_PASSION_DRAWER_OPENED',
  KYU101_RESOURCE_LIBRARY_OPENED: 'KYU101_RESOURCE_LIBRARY_OPENED',
  KYU101_FAQ_CLICKED: 'KYU101_FAQ_CLICKED',
  KYU101_MODAL_MINIMIZED: 'KYU101_MODAL_MINIMIZED',
  KYU101_MODAL_EXPANDED: 'KYU101_MODAL_EXPANDED',
  KYU101_MODAL_DISMISSED: 'KYU101_MODAL_DISMISSED',
  KYU101_TOC_CLICKED: 'KYU101_TOC_CLICKED',

  //TEAMING
  TEAMING_PERSON_CARD_CLICKED: 'TEAMING_PERSON_CARD_CLICKED',
  TEAMING_REFINE_RESULTS_CLICKED: 'TEAMING_REFINE_RESULTS_CLICKED',
  TEAMING_SEARCH_CLICKED: 'TEAMING_SEARCH_CLICKED',
  TEAMING_FILTER_MENU_CLICKED: 'TEAMING_FILTER_MENU_CLICKED',
  TEAMING_FILTER_SECTION_CLICKED: 'TEAMING_FILTER_SECTION_CLICKED',
  TEAMING_TOGGLE_CLICKED: 'TEAMING_TOGGLE_CLICKED',
  TEAMING_LOAD_MORE_CLICKED: 'TEAMING_LOAD_MORE_CLICKED',
  TEAMING_CONTACT_BANNER_CTA_CLICKED: 'TEAMING_CONTACT_BANNER_CTA_CLICKED',
  TEAMING_DRAWER_SELECT_CTA_CLICKED: 'TEAMING_DRAWER_SELECT_CTA_CLICKED',
  TEAMING_DRAWER_VIEW_PROFILE_CLICKED: 'TEAMING_DRAWER_VIEW_PROFILE_CLICKED',
  TEAMING_DRAWER_WORK_EXPERIENCE_TOGGLED: 'TEAMING_DRAWER_WORK_EXPERIENCE_TOGGLED',
  TEAMING_CONTACT_FLOW_MESSAGE_CTA_CLICKED: 'TEAMING_CONTACT_FLOW_MESSAGE_CTA_CLICKED',
  TEAMING_CONTACT_FLOW_SHARE_CTA_CLICKED: 'TEAMING_CONTACT_FLOW_SHARE_CTA_CLICKED',
  TEAMING_CONTACT_FLOW_RECIPIENT_TAB_CLICKED: 'TEAMING_CONTACT_FLOW_RECIPIENT_TAB_CLICKED',
  TEAMING_CONTACT_FLOW_EDIT_MESSAGE_CLICKED: 'TEAMING_CONTACT_FLOW_EDIT_MESSAGE_CLICKED',
  TEAMING_CONTACT_FLOW_REMOVE_RECIPIENT_CLICKED: 'TEAMING_CONTACT_FLOW_REMOVE_RECIPIENT_CLICKED',
  TEAMING_CONTACT_FLOW_CC_ADDED: 'TEAMING_CONTACT_FLOW_CC_ADDED',
  TEAMING_CONTACT_FLOW_PROFILE_DESELECTED: 'TEAMING_CONTACT_FLOW_PROFILE_DESELECTED',
  TEAMING_CONTACT_FLOW_SEND_CLICKED: 'TEAMING_CONTACT_FLOW_SEND_CLICKED',
  TEAMING_CONTACT_FLOW_DISMISSED: 'TEAMING_CONTACT_FLOW_DISMISSED',
  TEAMING_CONTACT_FLOW_BROADCAST_CTA_CLICKED: 'TEAMING_CONTACT_FLOW_BROADCAST_CTA_CLICKED',
  TEAMING_CONTACT_FLOW_EDIT_PROFILE_CLICKED: 'TEAMING_CONTACT_FLOW_EDIT_PROFILE_CLICKED',
  TEAMING_NLP_SEARCH_CLICKED: 'TEAMING_NLP_SEARCH_CLICKED',
  TEAMING_NLP_SEARCH_EDIT: 'TEAMING_NLP_SEARCH_EDIT',
  TEAMING_FILTER_ICON_CLICKED: 'TEAMING_FILTER_ICON_CLICKED',
  TEAMING_FILTERS_APPLIED: 'TEAMING_FILTERS_APPLIED',
  TEAMING_PRIORITIZE_CRITERIA_CLICKED: 'TEAMING_PRIORITIZE_CRITERIA_CLICKED',
  TEAMING_KEYWORD_CLICKED: 'TEAMING_KEYWORD_CLICKED',
  TEAMING_FILTER_CLICKED: 'TEAMING_FILTER_CLICKED',
  TEAMING_ALTERNATIVE_CLICKED: 'TEAMING_ALTERNATIVE_CLICKED',
  TEAMING_QUICK_FILTER_CLICKED: 'TEAMING_QUICK_FILTER_CLICKED',
  TEAMING_DRAWER_SEND_MESSAGE: 'TEAMING_DRAWER_SEND_MESSAGE',
  TEAMING_DRAWER_ADD: 'TEAMING_DRAWER_ADD',
  TEAMING_SHARE_LIST_CLICKED: 'TEAMING_SHARE_LIST_CLICKED',
  TEAMING_BROADCAST_CLICKED: 'TEAMING_BROADCAST_CLICKED',

  //PULSE
  PULSE_TAB_CLICKED: 'PULSE_TAB_CLICKED',
  PULSE_COMPANY_SWITCHER_CLICKED: 'PULSE_COMPANY_SWITCHER_CLICKED',
  PULSE_DOMAIN_LEAD_CLICKED: 'PULSE_DOMAIN_LEAD_CLICKED',
  PULSE_CONTACT_CTA_CLICKED: 'PULSE_CONTACT_CTA_CLICKED',
  PULSE_WIKI_SEARCH_CLICKED: 'PULSE_WIKI_SEARCH_CLICKED',
  PULSE_WIKI_CARD_CLICKED: 'PULSE_WIKI_CARD_CLICKED',
  PULSE_SPOTLIGHT_LINK_CLICKED: 'PULSE_SPOTLIGHT_LINK_CLICKED',
  PULSE_RESOURCE_CLICKED: 'PULSE_RESOURCE_CLICKED',
  PULSE_FAQ_SECTION_TAB_CLICKED: 'PULSE_FAQ_SECTION_TAB_CLICKED',

  //RESOURCE VOTE
  RESOURCE_VOTE_SHARE_CLICKED: 'RESOURCE_VOTE_SHARE_CLICKED',

  //BEST OF 2024
  BO24_MOST_VOTED_CLICKED: 'BO24_MOST_VOTED_CLICKED',
  BO24_TOP_CONTRIBUTOR_CLICKED: 'BO24_TOP_CONTRIBUTOR_CLICKED',
  BO24_CATEGORY_CLICKED: 'BO24_CATEGORY_CLICKED',
  BO24_TOP_ENTRY_CLICKED: 'BO24_TOP_ENTRY_CLICKED',
  RESOURCE_BO24_FILTER_CLICKED: 'RESOURCE_BO24_FILTER_CLICKED',
  PERSON_DRAWER_BO24_CLICKED: 'PERSON_DRAWER_BO24_CLICKED',
  PROFILE_RESOURCE_CLICKED: 'PROFILE_RESOURCE_CLICKED',

  //MESSAGES
  MESSAGE_POSTED: 'MESSAGE_POSTED',
  MESSAGE_EDITED: 'MESSAGE_EDITED',
  MESSAGE_DELETED: 'MESSAGE_DELETED',
  MESSAGE_MENTION_SELECTED: 'MESSAGE_MENTION_SELECTED',

  RESOURCE_FILTER_CLICKED: 'RESOURCE_FILTER_CLICKED',
  RESOURCE_SEARCH_SHARE_CTA_CLICKED: 'RESOURCE_SEARCH_SHARE_CTA_CLICKED',
  RESOURCE_GET_ASSISTANCE_CLICKED: 'RESOURCE_GET_ASSISTANCE_CLICKED',

  //BEST OF 2025
  BEST_OF_2025_SUBMISSION_PHASE_KYU_101_CLICKED: 'BEST_OF_2025_SUBMISSION_PHASE_KYU_101_CLICKED',
  BEST_OF_2025_SUBMISSION_PHASE_LAST_YEAR_RESOURCES_CLICKED:
    'BEST_OF_2025_SUBMISSION_PHASE_LAST_YEAR_RESOURCES_CLICKED',
  BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_CREATED: 'BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_CREATED',
  BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_EDITED: 'BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_EDITED',
  BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_WITHDRAWN:
    'BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_WITHDRAWN',

  // BEST OF V2
  BEST_OF_SUBMISSION_PHASE_KYU_101_CLICKED: 'BEST_OF_SUBMISSION_PHASE_KYU_101_CLICKED',
  BEST_OF_SUBMISSION_PHASE_LAST_YEAR_RESOURCES_CLICKED:
    'BEST_OF_SUBMISSION_PHASE_LAST_YEAR_RESOURCES_CLICKED',
  BEST_OF_SUBMISSION_PHASE_RESOURCE_CREATED: 'BEST_OF_SUBMISSION_PHASE_RESOURCE_CREATED',
  BEST_OF_SUBMISSION_PHASE_RESOURCE_EDITED: 'BEST_OF_SUBMISSION_PHASE_RESOURCE_EDITED',
  BEST_OF_SUBMISSION_PHASE_RESOURCE_WITHDRAWN: 'BEST_OF_SUBMISSION_PHASE_RESOURCE_WITHDRAWN',

  //BD100
  BD100_TAB_CLICKED: 'BD100_TAB_CLICKED',
  BD100_PROSPECT_DETAILS_OPENED: 'bd100_prospect_details_opened',
  BD100_PROSPECT_LIST_FILTERED: 'bd100_prospect_list_filtered',
  BD100_PROSPECT_DETAILS_EDITED: 'bd100_prospect_details_edited',
  BD100_PROSPECT_COLLABORATION_FLAG: 'bd100_prospect_collaboration_flag',
  BD100_CLIENT_DRAWER_OPENED: 'bd100_client_drawer_opened',
  BD100_PERSON_DRAWER_OPENED: 'bd100_person_drawer_opened',
  BD100_LINKEDIN_CLICKED: 'bd100_linkedin_clicked',
} as const;

export type BEHAVIORALS = (typeof BEHAVIORALS)[keyof typeof BEHAVIORALS];

const BEHAVIORAL_TO_SERVICE = new Map<BEHAVIORALS, Function>([
  [BEHAVIORALS.FULL_PROFILE_OPENED, putBehavioralFullProfileOpened],
  [BEHAVIORALS.LINKEDIN_OPENED, putBehavioralLinkedinOpened],
  [BEHAVIORALS.SLACK_OPENED, putBehavioralSlackOpened],
  [BEHAVIORALS.EMAIL_COPIED, putBehavioralEmailCopied],
  [BEHAVIORALS.MAP_OPENED, putBehavioralMapOpen],
  [BEHAVIORALS.PLATFORM_LINK_COPIED, putBehavioralPlatformLinkCopied],
  [BEHAVIORALS.SHARE_BANNER_CLICKED, putBehavioralShareBannerClicked],
  [BEHAVIORALS.GLOBAL_MAP_OPENED, putBehavioralGlobalMapOpen],
  [BEHAVIORALS.CONVENING_CLICKED, putBehavioralConveningClicked],
  [BEHAVIORALS.REGISTRATION_LINK_CLICKED, putBehavioralRegistrationLinkClicked],
  [BEHAVIORALS.WATCH_RECAP_CLICKED, putBehavioralWatchRecapClicked],
  [BEHAVIORALS.CONTINUE_EXPLORING_CLICKED, putBehavioralContinueExploringClicked],
  [BEHAVIORALS.ANCHOR_TAG_CLICKED, putBehavioralAnchorTagClicked],
  [BEHAVIORALS.ITEM_CLICKED, putBehavioralItemClicked],
  [BEHAVIORALS.NAV_ABOUT_KYU_OS, putBehavioralNavAboutKyuOsClicked],
  [BEHAVIORALS.NAV_NETWORK_MAPS, putBehavioralNavNetworkMapsClicked],
  [BEHAVIORALS.NAV_THE_WELL, putBehavioralNavTheWellClicked],
  [BEHAVIORALS.NAV_COMMUNITIES, putBehavioralNavCommunitiesClicked],
  [BEHAVIORALS.NAV_RESOURCES, putBehavioralNavResourcesClicked],
  [BEHAVIORALS.NAV_PEOPLE, putBehavioralNavPeopleClicked],
  [BEHAVIORALS.NAV_TEAMING, putBehavioralNavTeamingClicked],
  [BEHAVIORALS.NAV_EVENTS, putBehavioralNavEventsClicked],
  [BEHAVIORALS.NAV_DISCOVER, putBehavioralNavDiscoverClicked],
  [BEHAVIORALS.NAV_HOST_AN_EVENT, putBehavioralNavHostAnEventClicked],
  [BEHAVIORALS.NAV_PITCH_A_STORY, putBehavioralNavPitchAStoryClicked],
  [BEHAVIORALS.NAV_SUBMIT_A_RESOURCE, putBehavioralNavSubmitAResourceClicked],
  [BEHAVIORALS.NAV_OPENED, putBehavioralNavOpened],
  [BEHAVIORALS.NAV_HOMEPAGE_OPENED, putBehavioralNavHomepageOpened],
  [BEHAVIORALS.NAV_SPOTLIGHT_OPENED, putBehavioralNavSpotlightOpened],
  [BEHAVIORALS.NAV_SEARCH_OPENED, putBehavioralNavSearchOpened],
  [BEHAVIORALS.NAV_PROFILE_MENU_OPENED, putBehavioralNavProfileMenuOpened],
  [BEHAVIORALS.ACTIVITY_FEED_SPOTLIGHT_CLICKED, putBehavioralActivityFeedSpotlightClicked],
  [BEHAVIORALS.ACTIVITY_FEED_RADAR_TRENDING_CLICKED, putBehavioralActivityFeedRadarTrendingClicked],
  [
    BEHAVIORALS.ACTIVITY_FEED_RADAR_TRENDING_PILL_CLICKED,
    putBehavioralActivityFeedRadarTrendingPillClicked,
  ],
  [
    BEHAVIORALS.ACTIVITY_FEED_RADAR_ACTIVE_WORK_CLICKED,
    putBehavioralActivityFeedRadarActiveWorkClicked,
  ],
  [BEHAVIORALS.ACTIVITY_FEED_RADAR_PRESS_CLICKED, putBehavioralActivityFeedRadarPressClicked],
  [BEHAVIORALS.ACTIVITY_FEED_RADAR_EVENTS_CLICKED, putBehavioralActivityFeedRadarEventsClicked],
  [
    BEHAVIORALS.ACTIVITY_FEED_MEET_SOMEONE_NEW_CLICKED,
    putBehavioralActivityFeedMeetSomeoneNewClcked,
  ],
  [BEHAVIORALS.ACTIVITY_FEED_MAP_GALLERY_CLICKED, putBehavioralAcitivityFeedMapGalleryClicked],
  [BEHAVIORALS.DETAILS_ANNOUNCEMENT_CLICKED, putBehavioralDetailsAnnouncementClicked],
  [BEHAVIORALS.RESOURCE_DETAIL_CLICKED, putBehavioralResourceDetailsClicked],
  [BEHAVIORALS.RESOURCE_TAG_CATEGORY_CLICKED, putBehavioralTagCategoryClicked],
  [BEHAVIORALS.RESOURCE_TAG_SEARCH_CLICKED, putBehavioralTagSearchClicked],
  [BEHAVIORALS.RESOURCE_RELATED_RESOURCE_CLICKED, putBehavioralResourceRelatedResourceClicked],
  [BEHAVIORALS.RESOURCE_RELATED_PAGE_CLICKED, putBehavioralResourceRelatedPageClicked],
  [BEHAVIORALS.RESOURCE_LOAD_MORE_CLICKED, putBehavioralResourceLoadMoreClicked],
  [BEHAVIORALS.RESOURCE_OPENED, putBehavioralResourceOpen],
  [BEHAVIORALS.SEARCH_LENS_CLICKED, putBehavioralSearchLensClicked],
  [
    BEHAVIORALS.SEARCH_LENS_COLLECTIVE_DIRECTORY_CTA_CLICKED,
    putBehavioralSearchLensCollectiveDirectoryCTAClicked,
  ],
  [BEHAVIORALS.SEARCH_OPTIONS_LIST_ITEM_CLICKED, putBehavioralSearchOptionsListItemClicked],
  [BEHAVIORALS.GLOBAL_DRAWER_CTA_CLICKED, putBehavioralGlobalDrawerCTAClicked],
  [BEHAVIORALS.PERSON_CARD_CLICKED, putBehavioralPersonCardClicked],
  [BEHAVIORALS.PEOPLE_LIST_DRAWER_CTA_CLICKED, putBehavioralPeopleListDrawerCTAClicked],
  [BEHAVIORALS.PEOPLE_LIST_FILTERS_CTA_CLICKED, putBehavioralPeopleListFiltersCTAClicked],
  [BEHAVIORALS.MEET_SOMEONE_NEW_CAROUSEL_CLICKED, putBehavioralMeetSomeoneNewCarouselClicked],
  [
    BEHAVIORALS.MEET_SOMEONE_NEW_CAROUSEL_VIEW_PROFILE_CLICKED,
    putBehavioralMeetSomeoneNewViewProfileClicked,
  ],
  [BEHAVIORALS.PEOPLE_LIST_COMPANY_DROPDOWN_CLICKED, putBehavioralPeopleListCompanyDropdownClicked],
  [
    BEHAVIORALS.PEOPLE_LIST_COLLECTIVE_DIRECTORY_CTA_CLICKED,
    putBehavioralPeopleListCollectiveDirectoryCTAClicked,
  ],
  [BEHAVIORALS.ABOUT_DRAWER_CTA_CLICKED, putBehavioralAboutDrawerCTAClicked],
  [BEHAVIORALS.TOC_CLICKED, putBehavioralTOCClicked],
  [BEHAVIORALS.PEOPLE_DRAWER_FILTER_CLICKED, putBehavioralPeopleDrawerFilterClicked],
  [BEHAVIORALS.PEOPLE_DRAWER_ITEM_CLICKED, putBehavioralPeopleDrawerItemClicked],
  [BEHAVIORALS.COMMON_GROUND_CAROUSEL_CLICKED, putBehavioralCommonGroundCarouselClicked],
  [BEHAVIORALS.ACCOUNT_HOLDER_CLICKED, putAccountHolderClicked],
  [BEHAVIORALS.MAP_LENS_CLICKED, putBehavioralMapLensClicked],
  [BEHAVIORALS.MAP_NODE_CLICKED, putBehavioralMapNodeClicked],
  [BEHAVIORALS.MAP_DETAILS_PAGE_CTA_CLICKED, putBehavioralMapDetailsPageCTAClicked],

  [BEHAVIORALS.NAV_PROFILE_PROGRESS_BAR_CLICKED, putBehavioralNavProfileProgressBarClicked],
  [BEHAVIORALS.VIEW_PUBLIC_PROFILE_CLICKED, putBehavioralViewPublicProfileClicked],
  [BEHAVIORALS.EDIT_PROFILE_CLICKED, putBehavioralEditProfileClicked],
  [BEHAVIORALS.REACH_CARD_CLICKED, putBehavioralReachCardClicked],
  [BEHAVIORALS.BUILD_PROFILE_CLICKED, putBehavioralBuildProfileClicked],
  [BEHAVIORALS.NO_PROJECTS_CLICKED, putBehavioralNoProjectsClicked],
  [BEHAVIORALS.REQUEST_CHANGE_CLICKED, putBehavioralRequestChangeClicked],
  [BEHAVIORALS.RESOURCE_CARD_SUBMITTER_CLICKED, putBehavioralResourceCardSubmitterClicked],
  [BEHAVIORALS.RESOURCE_CARD_CREATOR_CLICKED, putBehavioralResourceCardCreatorClicked],
  [BEHAVIORALS.RESOURCE_DETAIL_CREATOR_CLICKED, putBehavioralResourceDetailCreatorClicked],
  [BEHAVIORALS.RESOURCE_CREATE_CTA_CLICKED, putBehavioralResourceCreateCtaClicked],
  [BEHAVIORALS.ARTICLE_CONTRIBUTOR_CLICKED, putBehavioralArticleContributorClicked],
  [BEHAVIORALS.ARTICLE_PROFILE_LINK_OUT_CLICKED, putBehavioralArticleProfileLinkOutClicked],
  [BEHAVIORALS.CONVENING_ATTENDEE_CLICKED, putBehavioralConveningAttendeeClicked],
  [BEHAVIORALS.CONVENING_HOST_CLICKED, putBehavioralConveningHostClicked],
  [BEHAVIORALS.SHARE_BUTTON_CLICKED, putBehavioralShareButtonClicked],
  [BEHAVIORALS.REACTIONS_LIST_OPENED, putBehavioralReactionsListOpened],
  [BEHAVIORALS.REACTIONS_VIEW_PROFILE_CLICKED, putBehavioralReactionsViewProfileClicked],
  [BEHAVIORALS.REACTIONS_PROFILE_SEE_ALL_CLICKED, putBehavioralReactionsProfileSeeAllClicked],
  [BEHAVIORALS.REACTIONS_PERSON_DRAWER_CARD_CLICKED, putBehavioralReactionsPersonDrawerCardClicked],
  [
    BEHAVIORALS.COLLECTIVE_DIRECTORY_ONBOARDING_PROMPT_CLICKED,
    putCollectiveDirectoryOnboardingPromptClicked,
  ],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_PERSON_CARD_CLICKED, putCollectiveDirectoryPersonCardClicked],
  [
    BEHAVIORALS.COLLECTIVE_DIRECTORY_SELECT_RECIPIENTS_CLICKED,
    putCollectiveDirectorySelectRecipientsClicked,
  ],
  [
    BEHAVIORALS.COLLECTIVE_DIRECTORY_REFINE_RESULTS_CLICKED,
    putCollectiveDirectoryRefineResultsClicked,
  ],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_QUICK_FILTER_CLICKED, putCollectiveDirectoryQuickFilterClicked],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_PROFILE_CTA_CLICKED, putCollectiveDirectoryProfileCtaClicked],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_SEARCH_RESULT_CLICKED, putCollectiveDirectorySearchClicked],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_FILTER_MENU_CLICKED, putCollectiveDirectoryFilterMenuClicked],
  [
    BEHAVIORALS.COLLECTIVE_DIRECTORY_FILTER_SECTION_CLICKED,
    putCollectiveDirectoryFilterSectionClicked,
  ],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_TOGGLE_CLICKED, putCollectiveDirectoryToggleClicked],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_LOAD_MORE_CLICKED, putCollectiveDirectoryLoadMoreClicked],
  [
    BEHAVIORALS.COLLECTIVE_DIRECTORY_PERSON_DRAWER_FILTER_CLICKED,
    putCollectiveDirectoryPersonDrawerFilterClicked,
  ],
  [
    BEHAVIORALS.COLLECTIVE_DIRECTORY_PRIORITIZE_CRITERIA_CLICKED,
    putCollectiveDirectoryPrioritizeCriteriaClicked,
  ],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_KEYWORD_CLICKED, putCollectiveDirectoryKeywordClicked],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_FILTER_CLICKED, putCollectiveDirectoryFilterClicked],
  [BEHAVIORALS.COLLECTIVE_DIRECTORY_ALTERNATIVE_CLICKED, putCollectiveDirectoryAlternativeClicked],
  [
    BEHAVIORALS.COLLECTIVE_INDEX_DRAWER_SELECT_CTA_CLICKED,
    putCollectiveIndexDrawerSelectCTAClicked,
  ],
  [
    BEHAVIORALS.COLLECTIVE_INDEX_CONTACT_BANNER_CTA_CLICKED,
    putCollectiveIndexContactBannerCtaClicked,
  ],
  [BEHAVIORALS.CONTACT_FLOW_SELECT_ALL_CLICKED, putContactFlowSelectAllClicked],
  [BEHAVIORALS.CONTACT_FLOW_COPY_PROFILE_CLICKED, putContactFlowCopyProfileClicked],
  [BEHAVIORALS.CONTACT_FLOW_DESELECT_PROFILE_CLICKED, putContactFlowDeselectProfileClicked],
  [
    BEHAVIORALS.CONTACT_FLOW_PARTIAL_MATCH_SELECTION_CLICKED,
    putContactFlowPartialMatchSelectionClicked,
  ],
  [BEHAVIORALS.CONTACT_FLOW_SEND_CLICKED, putContactFlowSendClicked],
  [BEHAVIORALS.CONTACT_FLOW_BACK_CLICKED, putContactFlowBackClicked],
  [BEHAVIORALS.CONTACT_FLOW_DISMISSED, putContactFlowDismissed],
  [BEHAVIORALS.CONTACT_FLOW_EDIT_PROFILE_CLICKED, putContactFlowEditProfileClicked],
  [BEHAVIORALS.FEATURE_BANNER_DISMISSED, putBehavioralFeatureBannerDismissed],
  [BEHAVIORALS.FEATURE_BANNER_CTA_CLICKED, putBehavioralFeatureBannerCTAClicked],
  [BEHAVIORALS.KYU101_PROFILE_EDIT_DRAWER_OPENED, putKyu101ProfileEditDrawerOpened],
  [BEHAVIORALS.KYU101_PUBLIC_PROFILE_CTA_CLICKED, putKyu101PublicProfileCtaClicked],
  [BEHAVIORALS.KYU101_REACH_CTA_CLICKED, putKyu101ReachCtaClicked],
  [BEHAVIORALS.KYU101_PEOPLE_SECTION_CTA_CLICKED, putKyu101PeopleSectionCtaClicked],
  [BEHAVIORALS.KYU101_COMPANY_PAGE_CTA_CLICKED, putKyu101CompanyPageCtaClicked],
  [BEHAVIORALS.KYU101_COMPANY_CLIENTS_CLICKED, putKyu101CompanyClientsClicked],
  [BEHAVIORALS.KYU101_COMPANIES_DRAWER_OPENED, putKyu101CompaniesDrawerOpened],
  [BEHAVIORALS.KYU101_RESOURCES_OPENED, putKyu101ResourcesOpened],
  [BEHAVIORALS.KYU101_THE_WELL_OPENED, putKyu101TheWellOpened],
  [BEHAVIORALS.KYU101_CONVENINGS_OPENED, putKyu101ConveningsOpened],
  [BEHAVIORALS.KYU101_USECASES_OPENED, putKyu101UsecasesOpened],
  [BEHAVIORALS.KYU101_CONTACT_FORM_OPENED, putKyu101ContactFormOpened],
  [
    BEHAVIORALS.KYU101_CASUAL_INTENTION_COLLECTIVE_DIRECTORY_OPENED,
    putKyu101CasualIntentionCollectiveDirectoryOpened,
  ],
  [
    BEHAVIORALS.KYU101_EXPERTISE_INTENTION_COLLECTIVE_DIRECTORY_OPENED,
    putKyu101ExpertiseIntentionCollectiveDirectoryOpened,
  ],
  [
    BEHAVIORALS.KYU101_CONVENE_INTENTION_COLLECTIVE_DIRECTORY_OPENED,
    putKyu101ConveneIntentionCollectiveDirectoryOpened,
  ],
  [BEHAVIORALS.KYU101_CLIENTS_DRAWER_OPENED, putKyu101ClientsDrawerOpened],
  [BEHAVIORALS.KYU101_GLOBAL_INDUSTRIES_DRAWER_OPENED, putKyu101GlobalIndustriesDrawerOpened],
  [BEHAVIORALS.KYU101_COLLECTIVE_DIRECTORY_OPENED, putKyu101CollectiveDirectoryOpened],
  [BEHAVIORALS.KYU101_GLOBAL_DISCIPLINE_DRAWER_OPENED, putKyu101GlobalDisciplineDrawerOpened],
  [BEHAVIORALS.KYU101_GLOBAL_INDUSTRY_DRAWER_OPENED, putKyu101GlobalIndustryDrawerOpened],
  [BEHAVIORALS.KYU101_GLOBAL_CLIENT_DRAWER_OPENED, putKyu101GlobalClientDrawerOpened],
  [BEHAVIORALS.KYU101_GLOBAL_SKILL_DRAWER_OPENED, putKyu101GlobalSkillDrawerOpened],
  [BEHAVIORALS.KYU101_GLOBAL_PASSION_DRAWER_OPENED, putKyu101GlobalPassionDrawerOpened],
  [BEHAVIORALS.KYU101_RESOURCE_LIBRARY_OPENED, putKyu101ResourceLibraryOpened],
  [BEHAVIORALS.KYU101_FAQ_CLICKED, putKyu101FaqClicked],
  [BEHAVIORALS.KYU101_MODAL_MINIMIZED, putKyu101ModalMinimized],
  [BEHAVIORALS.KYU101_MODAL_EXPANDED, putKyu101ModalExpanded],
  [BEHAVIORALS.KYU101_MODAL_DISMISSED, putKyu101ModalDismissed],
  [BEHAVIORALS.KYU101_TOC_CLICKED, putKyu101TocClicked],
  [BEHAVIORALS.TEAMING_PERSON_CARD_CLICKED, putTeamingPersonCardClicked],
  [BEHAVIORALS.TEAMING_REFINE_RESULTS_CLICKED, putTeamingRefineResultsClicked],
  [BEHAVIORALS.TEAMING_SEARCH_CLICKED, putTeamingSearchClicked],
  [BEHAVIORALS.TEAMING_FILTER_MENU_CLICKED, putTeamingFilterMenuClicked],
  [BEHAVIORALS.TEAMING_FILTER_SECTION_CLICKED, putTeamingFilterSectionClicked],
  [BEHAVIORALS.TEAMING_TOGGLE_CLICKED, putTeamingToggleClicked],
  [BEHAVIORALS.TEAMING_LOAD_MORE_CLICKED, putTeamingLoadMoreClicked],
  [BEHAVIORALS.TEAMING_CONTACT_BANNER_CTA_CLICKED, putTeamingContactBannerCtaClicked],
  [BEHAVIORALS.TEAMING_DRAWER_SELECT_CTA_CLICKED, putTeamingDrawerSelectCtaClicked],
  [BEHAVIORALS.TEAMING_DRAWER_VIEW_PROFILE_CLICKED, putTeamingDrawerViewProfileClicked],
  [BEHAVIORALS.TEAMING_DRAWER_WORK_EXPERIENCE_TOGGLED, putTeamingDrawerWorkExperienceToggled],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_MESSAGE_CTA_CLICKED, putTeamingContactFlowMessageCtaClicked],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_SHARE_CTA_CLICKED, putTeamingContactFlowShareCtaClicked],
  [
    BEHAVIORALS.TEAMING_CONTACT_FLOW_RECIPIENT_TAB_CLICKED,
    putTeamingContactFlowRecipientTabClicked,
  ],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_EDIT_MESSAGE_CLICKED, putTeamingContactFlowEditMessageClicked],
  [
    BEHAVIORALS.TEAMING_CONTACT_FLOW_REMOVE_RECIPIENT_CLICKED,
    putTeamingContactFlowRemoveRecipientClicked,
  ],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_CC_ADDED, putTeamingContactFlowCcAdded],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_PROFILE_DESELECTED, putTeamingContactFlowProfileDeselected],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_SEND_CLICKED, putTeamingContactFlowSendClicked],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_DISMISSED, putTeamingContactFlowDismissed],
  [
    BEHAVIORALS.TEAMING_CONTACT_FLOW_BROADCAST_CTA_CLICKED,
    putTeamingContactFlowBroadcastCtaClicked,
  ],
  [BEHAVIORALS.TEAMING_CONTACT_FLOW_EDIT_PROFILE_CLICKED, putTeamingContactFlowEditProfileClicked],
  [BEHAVIORALS.TEAMING_PRIORITIZE_CRITERIA_CLICKED, putTeamingPrioritizeCriteriaClicked],
  [BEHAVIORALS.TEAMING_KEYWORD_CLICKED, putTeamingKeywordClicked],
  [BEHAVIORALS.TEAMING_FILTER_CLICKED, putTeamingFilterClicked],
  [BEHAVIORALS.TEAMING_ALTERNATIVE_CLICKED, putTeamingAlternativeClicked],
  [BEHAVIORALS.TEAMING_QUICK_FILTER_CLICKED, putTeamingQuickFilterClicked],
  [BEHAVIORALS.TEAMING_DRAWER_SEND_MESSAGE, putTeamingDrawerSendMessageClicked],
  [BEHAVIORALS.TEAMING_DRAWER_ADD, putTeamingDrawerAddClicked],
  [BEHAVIORALS.TEAMING_SHARE_LIST_CLICKED, putTeamingShareListClicked],
  [BEHAVIORALS.TEAMING_BROADCAST_CLICKED, putTeamingBroadcastClicked],
  [BEHAVIORALS.PULSE_TAB_CLICKED, putPulseTabClicked],
  [BEHAVIORALS.PULSE_COMPANY_SWITCHER_CLICKED, putPulseCompanySwitcherClicked],
  [BEHAVIORALS.PULSE_DOMAIN_LEAD_CLICKED, putPulseDomainLeadClicked],
  [BEHAVIORALS.PULSE_CONTACT_CTA_CLICKED, putPulseContactCtaClicked],
  [BEHAVIORALS.PULSE_WIKI_SEARCH_CLICKED, putPulseWikiSearchClicked],
  [BEHAVIORALS.PULSE_WIKI_CARD_CLICKED, putPulseWikiCardClicked],
  [BEHAVIORALS.PULSE_SPOTLIGHT_LINK_CLICKED, putPulseSpotlightLinkClicked],
  [BEHAVIORALS.PULSE_RESOURCE_CLICKED, putPulseResourceClicked],
  [BEHAVIORALS.PULSE_FAQ_SECTION_TAB_CLICKED, putPulseFaqSectionTabClicked],
  [BEHAVIORALS.RESOURCE_VOTE_SHARE_CLICKED, putResourceVoteShareClicked],
  [BEHAVIORALS.BO24_MOST_VOTED_CLICKED, putBO24MostVotedClicked],
  [BEHAVIORALS.BO24_TOP_CONTRIBUTOR_CLICKED, putBO24TopContributorClicked],
  [BEHAVIORALS.BO24_CATEGORY_CLICKED, putBO24CategoryClicked],
  [BEHAVIORALS.BO24_TOP_ENTRY_CLICKED, putBO24TopEntryClicked],
  [BEHAVIORALS.RESOURCE_BO24_FILTER_CLICKED, putResourceBo24Filter],
  [BEHAVIORALS.PERSON_DRAWER_BO24_CLICKED, putPersonDrawerBo24Clicked],
  [BEHAVIORALS.PROFILE_RESOURCE_CLICKED, putProfileResourceClicked],
  [BEHAVIORALS.COLLECTIVE_INDEX_NLP_SEARCH_CLICKED, putCollectiveIndexNlpSearchClicked],
  [BEHAVIORALS.COLLECTIVE_INDEX_NLP_SEARCH_EDIT, putCollectiveIndexNlpSearchEdit],
  [BEHAVIORALS.COLLECTIVE_INDEX_FILTER_ICON_CLICKED, putCollectiveIndexFilterIconClicked],
  [BEHAVIORALS.COLLECTIVE_INDEX_FILTERS_APPLIED, putCollectiveIndexFiltersApplied],
  [BEHAVIORALS.TEAMING_NLP_SEARCH_CLICKED, putTeamingNlpSearchClicked],
  [BEHAVIORALS.TEAMING_NLP_SEARCH_EDIT, putTeamingNlpSearchEdit],
  [BEHAVIORALS.TEAMING_FILTER_ICON_CLICKED, putTeamingFilterIconClicked],
  [BEHAVIORALS.TEAMING_FILTERS_APPLIED, putTeamingFiltersApplied],
  [BEHAVIORALS.MESSAGE_POSTED, putMessagePosted],
  [BEHAVIORALS.MESSAGE_EDITED, putMessageEdited],
  [BEHAVIORALS.MESSAGE_DELETED, putMessageDeleted],
  [BEHAVIORALS.MESSAGE_MENTION_SELECTED, putMessageMentionSelected],
  [BEHAVIORALS.RESOURCE_FILTER_CLICKED, putResourceFilterClicked],
  [BEHAVIORALS.RESOURCE_SEARCH_SHARE_CTA_CLICKED, putResourceSearchShareCtaClicked],
  [BEHAVIORALS.RESOURCE_GET_ASSISTANCE_CLICKED, putResourceGetAssistanceClicked],
  [
    BEHAVIORALS.BEST_OF_2025_SUBMISSION_PHASE_KYU_101_CLICKED,
    putBestOf2025SubmissionPhaseKyu101Clicked,
  ],
  [
    BEHAVIORALS.BEST_OF_2025_SUBMISSION_PHASE_LAST_YEAR_RESOURCES_CLICKED,
    putBestOf2025SubmissionPhaseLastYearResourcesClicked,
  ],
  [
    BEHAVIORALS.BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_CREATED,
    putBestOf2025SubmissionPhaseResourceCreated,
  ],
  [
    BEHAVIORALS.BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_EDITED,
    putBestOf2025SubmissionPhaseResourceEdited,
  ],
  [
    BEHAVIORALS.BEST_OF_2025_SUBMISSION_PHASE_RESOURCE_WITHDRAWN,
    putBestOf2025SubmissionPhaseResourceWithdrawn,
  ],
  [BEHAVIORALS.BEST_OF_SUBMISSION_PHASE_KYU_101_CLICKED, putBestOfSubmissionPhaseKyu101Clicked],
  [
    BEHAVIORALS.BEST_OF_SUBMISSION_PHASE_LAST_YEAR_RESOURCES_CLICKED,
    putBestOfSubmissionPhaseLastYearResourcesClicked,
  ],
  [BEHAVIORALS.BEST_OF_SUBMISSION_PHASE_RESOURCE_CREATED, putBestOfSubmissionPhaseResourceCreated],
  [BEHAVIORALS.BEST_OF_SUBMISSION_PHASE_RESOURCE_EDITED, putBestOfSubmissionPhaseResourceEdited],
  [
    BEHAVIORALS.BEST_OF_SUBMISSION_PHASE_RESOURCE_WITHDRAWN,
    putBestOfSubmissionPhaseResourceWithdrawn,
  ],
  [BEHAVIORALS.BD100_TAB_CLICKED, putBd100TabClicked],
  [BEHAVIORALS.BD100_PROSPECT_DETAILS_OPENED, putBd100ProspectDetailsOpen],
  [BEHAVIORALS.BD100_PROSPECT_LIST_FILTERED, putBd100ProspectListFiltered],
]);

export default function useBehavioral(behavioral: BEHAVIORALS, extraParams?: any) {
  const behavioralId = useSelector(behavioralIdSelector);

  const behavioralFunction = (moreParams = {}) => {
    if (extraParams?.behavioralId || behavioralId) {
      const behavioralService = BEHAVIORAL_TO_SERVICE.get(behavioral);
      if (behavioralService) {
        behavioralService({
          behavioral_id: extraParams?.behavioralId || behavioralId,
          ...extraParams,
          ...moreParams,
        });
      } else {
        putBehavioral(behavioral, extraParams?.behavioralId || behavioralId, {
          ...extraParams,
          ...moreParams,
        });
      }
    }
  };

  return behavioralFunction;
}
